// CONSULTATION CHAT: Strict client-side personal info filter for in-app consultations.
export const PERSONAL_INFO_BLOCK_TEXT = "[Personal info blocked by Petaar]";

const EMAIL_RE = /\b[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}\b/gi;
const WHATSAPP_RE = /\b(?:whatsapp|whats\s*app|whatsapp\s*me|wa\.me)\b/gi;
const UPI_RE = /\b[a-z0-9._-]{2,}@(upi|okaxis|okhdfcbank|okicici|oksbi|okyes|paytm|ybl|ibl)\b/gi;
const SOCIAL_KEYWORD_RE = /\b(?:instagram|facebook|telegram|snapchat)\b[^\n\r]{0,40}/gi;
const SOCIAL_HANDLE_RE = /(^|\s)@[a-z0-9_][a-z0-9_.]{1,29}\b/gi;
const URL_RE = /\bhttps?:\/\/[^\s<>"')]+/gi;
const PHONE_CANDIDATE_RE = /(?:\+?\d[\d\s-]{8,}\d)/g;
const STRAIGHT_10_DIGIT_RE = /\b\d{10}\b/g;

function isAllowedPetaarUrl(url) {
  try {
    const parsed = new URL(String(url || "").trim());
    const host = String(parsed.hostname || "").toLowerCase();
    return host === "petaar.com" || host === "www.petaar.com" || host.endsWith(".petaar.com");
  } catch (_) {
    return false;
  }
}

function blockByRegex(input, regex, blockedHits) {
  return input.replace(regex, (match) => {
    blockedHits.push(match);
    return PERSONAL_INFO_BLOCK_TEXT;
  });
}

function blockPhoneCandidates(input, blockedHits) {
  const replacedCandidates = input.replace(PHONE_CANDIDATE_RE, (match) => {
    const digitsOnly = String(match || "").replace(/\D/g, "");
    if (digitsOnly.length < 10 || digitsOnly.length > 13) {
      return match;
    }
    blockedHits.push(match);
    return PERSONAL_INFO_BLOCK_TEXT;
  });
  return replacedCandidates.replace(STRAIGHT_10_DIGIT_RE, (match) => {
    blockedHits.push(match);
    return PERSONAL_INFO_BLOCK_TEXT;
  });
}

export function filterPersonalInfo(text) {
  const raw = String(text || "");
  if (!raw.trim()) {
    return {
      filteredText: raw,
      blocked: false,
      blockedHits: [],
    };
  }

  const blockedHits = [];
  let filtered = raw;

  filtered = blockByRegex(filtered, EMAIL_RE, blockedHits);
  filtered = blockByRegex(filtered, WHATSAPP_RE, blockedHits);
  filtered = blockByRegex(filtered, UPI_RE, blockedHits);
  filtered = blockByRegex(filtered, SOCIAL_KEYWORD_RE, blockedHits);
  filtered = blockByRegex(filtered, SOCIAL_HANDLE_RE, blockedHits);
  filtered = blockPhoneCandidates(filtered, blockedHits);
  filtered = filtered.replace(URL_RE, (url) => {
    if (isAllowedPetaarUrl(url)) return url;
    blockedHits.push(url);
    return PERSONAL_INFO_BLOCK_TEXT;
  });

  return {
    filteredText: filtered,
    blocked: blockedHits.length > 0,
    blockedHits,
  };
}

